export default {
  header: 'KFF - Custom State Reports\n',
  footer: '\n"Footnotes, Notes, Sources & Definitions"',
};



// WEBPACK FOOTER //
// ./app/config/csv.js